import { createAction } from 'redux-act';
import { ICountry } from 'modules/ScrShop/store/types';

export const fetchCountriesAction = createAction();
export const fetchCountriesOnSuccess = createAction<ICountry[]>();
